import { forwardRef, HTMLProps } from 'react'
import { FieldError } from 'react-hook-form'

interface SwitchInputProps extends HTMLProps<HTMLInputElement> {
  label: string
  error?: FieldError | undefined
}

export const SwitchInput = forwardRef<HTMLInputElement, SwitchInputProps>(function SwitchInput(
  { id, label, error, ...rest },
  ref,
) {
  return (
    <>
      <label className="inline-flex items-center cursor-pointer">
        <input id={id} ref={ref} type="checkbox" className="sr-only peer" {...rest} />
        <div className="relative w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-400 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all peer-checked:bg-indigo-600" />
        <span className="ms-3 text-sm font-medium text-gray-900">{label}</span>
      </label>
      {
        error?.message !== '' && (
          <span className="text-xs font-medium text-red-500">
            {error?.message}
          </span>
        )
      }
    </>
  )
})
